import { render, staticRenderFns } from "./PrivacyNew.vue?vue&type=template&id=3a1f589f&scoped=true&"
import script from "./PrivacyNew.vue?vue&type=script&lang=js&"
export * from "./PrivacyNew.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNew.vue?vue&type=style&index=0&id=3a1f589f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f589f",
  null
  
)

export default component.exports